import * as Yup from "yup";

export const personArtForm: FormConfig<PersonArtDTO> = {
  title: "personart",
  validationSchema: Yup.object({
    personartNrNavigationNavn: Yup.string().required("Personart skal være sat"),
    periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
    periodeTilDatoInklusiv: Yup.date()
      .nullable()
      .when(
        "fraDato",
        (fraDato, yup) =>
          fraDato && yup.min(fraDato, "Slutdato kan ikke være før startdato"),
      ),
  }),
  form: [
    {
      component: "kode-select",
      kodeListeType: "PersonartKode",
      id: "personartNrNavigationNavn",
      label: "Personart",
      placeholder: "Vælg personart",
      initialValue: "",
      isRequired: true,
    },
    {
      component: "datepicker",
      id: "periodeFraDato",
      label: "Startdato",
      initialValue: "",
      isRequired: true,
    },
    {
      component: "datepicker",
      id: "periodeTilDatoInklusiv",
      label: "Slutdato",
      initialValue: "",
    },
  ],
  get: ``,
};
